import { createStyles, withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
// @ts-ignore
const FTLStyledTableCellComponent = withStyles((theme) => createStyles({
    head: {
        // backgroundColor: theme.palette.common.black,
        // color: theme.palette.common.white,
        fontWeight: 'bold'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
export default FTLStyledTableCellComponent;
//# sourceMappingURL=FTLStyledTableCellComponent.js.map